import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RenderingState, ErrorInfo } from 'redux/types';
import { RootState } from 'redux/root-reducer';

const initialState: RenderingState = {
  isLoading: false,
  success: false,
  error: {
    message: '',
    statusCode: null,
  },
};

const createJobSlice = createSlice({
  name: 'CREATE_JOB',
  initialState,
  reducers: {
    loading: (state) => {
      state.isLoading = true;
    },
    success: (state) => {
      state.isLoading = false;
      state.success = true;
      state.error = initialState.error;
    },
    failure: (state, action: PayloadAction<ErrorInfo>) => {
      state.isLoading = false;
      state.error.message = action.payload.message;
      state.error.statusCode = action.payload.statusCode;
    },
    resetToInitials: (state) => {
      state.isLoading = false;
      state.success = false;
      state.error = {
        message: '',
        statusCode: null,
      };
    },
  },
});

// REDUCER
export default createJobSlice.reducer;

// ACTIONS
export const { loading, success, failure, resetToInitials } = createJobSlice.actions;

// SELECTORS
export const selectIsLoading = (state: RootState) =>
  state.ui.job.create.jobDetails.isLoading;
export const selectSuccess = (state: RootState) => state.ui.job.create.jobDetails.success;
export const selectError = (state: RootState) => state.ui.job.create.jobDetails.error;
